import { Component, Inject, OnInit } from '@angular/core';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { IProduct, IVariant } from '../../models/products.models';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-details-technical-dialog-edits',
  templateUrl: './details-technical-dialog-edits.component.html',
  styleUrls: ['./details-technical-dialog-edits.component.scss']
})
export class DetailsTechnicalDialogEditsComponent implements OnInit {
  public Editor = ClassicEditor;
  form!: FormGroup;
  selectedVariant: IVariant | undefined = undefined;
  selectedValues: { [key: string]: string } = {};

  public editorConfig = {
    placeholder: this.translate.instant('inventory.edit_technical.technical_details_placeholder'),
    toolbar: {
      shouldNotGroupWhenFull: true,
      items: [
        'undo', 'redo', '|',
        'heading', '|',
        'bold', 'italic', 'link', 'insertTable', 'blockQuote', '|',
        'bulletedList', 'numberedList', '|',
        'outdent', 'indent', '|',
        'alignment'
      ]
    }
  };

  constructor(
    public dialogRef: MatDialogRef<DetailsTechnicalDialogEditsComponent>,
    private translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: IProduct,
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {
    if (this.isVariantProduct()) {
      if (this.data.attributes && this.data.attributes.length > 0) {
        this.data.attributes.forEach((attribute) => {
          this.selectedValues[attribute.name] = attribute.values[0];
        });
        this.updateSelectedVariant();
      }
      const initialVariant = this.selectedVariant || this.data.variants?.[0];
      this.form = this.fb.group({
        technical_details: new FormControl(initialVariant?.technical_details ?? ''),
      });
    } else {
      this.form = this.fb.group({
        technical_details: new FormControl(this.data?.technical_details ?? ''),
      });
    }
  }

  isVariantProduct(): boolean {
    return !!(this.data.variants && this.data.variants.length > 1);
  }

  selectAttributeValue(attribute: string, value: string): void {
    if (this.isVariantProduct() && this.selectedVariant) {
      const currentTechnicalDetails = this.form.get('technical_details')?.value || '';
      this.selectedVariant.technical_details = currentTechnicalDetails;
    }

    this.selectedValues[attribute] = value;
    this.updateSelectedVariant();
    
    if (this.isVariantProduct() && this.selectedVariant) {
      this.form.patchValue({
        technical_details: this.selectedVariant.technical_details ?? ''
      });
    }
  }

  isSelected(attribute: string, value: string): boolean {
    return this.selectedValues[attribute] === value;
  }

  updateSelectedVariant(): void {
    const selectedAttributes = Object.values(this.selectedValues);
    this.selectedVariant = this.data.variants?.find((variant) =>
      selectedAttributes.every((val) => variant.values.includes(val))
    );
  }

  save() {
    if (this.isVariantProduct()) {
      if (this.selectedVariant) {
        const currentTechnicalDetails = this.form.get('technical_details')?.value || '';
        this.selectedVariant.technical_details = currentTechnicalDetails;
      }

      const variantsWithTechnicalDetails = this.data.variants?.map((variant) => ({
        id: variant.id,
        technical_details: variant.technical_details ?? ''
      })) || [];

      this.dialogRef.close(variantsWithTechnicalDetails);
    } else {
      const technicalDetails = this.form.get('technical_details')?.value || '';
      this.dialogRef.close({technicalDetails});
    }
  }

  cancel() {
    this.dialogRef.close();
  }
}
